import React from 'react';

import Switch from '@mui/material/Switch';

import AdminTablePage from '@/pwa/templates/AdminTablePage/AdminTablePage';
import DataTable, {
  GridColDef,
  GridRenderCellParams,
} from '@/pwa/organisms/DataTable/DataTable';

export interface PartnerProductRow {
  id: string;
  name: string;
  requiresPartnerCode: boolean;
  requiresLicenceCode: boolean;
}

export interface PartnerProductTablePageProps {
  rows: PartnerProductRow[];
  onToggle?: (
    productId: string,
    field: 'requiresPartnerCode' | 'requiresLicenceCode',
    currentValue: boolean,
  ) => void;
}

export const PartnerProductTablePage = ({
  rows,
  onToggle,
}: PartnerProductTablePageProps) => {
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Product Name',
      flex: 1,
      minWidth: 200,
    },
    {
      field: 'requiresPartnerCode',
      headerName: 'Requires Partner Code',
      flex: 0.6,
      minWidth: 180,
      renderCell: (params: GridRenderCellParams) => (
        <Switch
          checked={params.value as boolean}
          onChange={() =>
            onToggle?.(
              params.row.id,
              'requiresPartnerCode',
              params.value as boolean,
            )
          }
        />
      ),
    },
    {
      field: 'requiresLicenceCode',
      headerName: 'Requires Licence Code',
      flex: 0.6,
      minWidth: 180,
      renderCell: (params: GridRenderCellParams) => (
        <Switch
          checked={params.value as boolean}
          onChange={() =>
            onToggle?.(
              params.row.id,
              'requiresLicenceCode',
              params.value as boolean,
            )
          }
        />
      ),
    },
  ];

  return (
    <AdminTablePage title='Partner Product Management'>
      <DataTable columns={columns} rows={rows} />
    </AdminTablePage>
  );
};

PartnerProductTablePage.displayName = 'PartnerProductTablePage';
export default PartnerProductTablePage;
